module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIuNDEyIDEuNDEyTDE1LjY5IDE0LjY5bS0uMTAyLTEzLjI3OEwyLjMxIDE0LjY5IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iI0ZGRkZGRiIgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = mq5u
// module chunks = 1